(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceNoRequireDialogController', TowerServiceNoRequireDialogController);

    TowerServiceNoRequireDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TowerServiceNoRequire'];

    function TowerServiceNoRequireDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TowerServiceNoRequire) {
        var vm = this;

        vm.towerServiceNoRequire = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerServiceNoRequire.id !== null) {
                TowerServiceNoRequire.update(vm.towerServiceNoRequire, onSaveSuccess, onSaveError);
            } else {
                TowerServiceNoRequire.save(vm.towerServiceNoRequire, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerServiceNoRequireUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
